import React from 'react'
import { Button, InputNumber, Space, theme, Tooltip, Typography } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { DATAHUB_LINK_MAX } from './datahub-interfaces'

interface DatahubLinkMaxInputProps {
  label: string
  value: number
  onChange: (value: number) => void
}

/**
 * Input to set the maximum number of links to display
 * @param label - The label of the input
 * @param value - The value of the input
 * @param onChange - The function to call when the value changes
 * @returns The input
 */
export function DatahubLinkMaxInput({
  label,
  value,
  onChange,
}: DatahubLinkMaxInputProps) {
  const { token } = theme.useToken()
  const isZero = value === 0
  const isMax = value === DATAHUB_LINK_MAX
  const isCustom = !isZero && !isMax

  return (
    <div>
      <Typography.Text type="secondary">
        {label}
        <Tooltip 
          title={<div style={{ whiteSpace: 'pre-line' }}>Vous pouvez choisir entre :<br />- 0 (pas d'affichage de l'onglet)<br />- MAX (pas de limite prise en compte)<br />- un nombre personnalisé (limite affichée explicitement pour l'utilisateur)</div>}
        >
          <InfoCircleOutlined style={{ marginLeft: 6, color: 'rgba(0,0,0,0.45)' }} />
        </Tooltip>
      </Typography.Text>
      <Space.Compact style={{ width: '100%', marginTop: 4 }}>
        <Button
          size="small"
          type={isZero ? 'primary' : 'default'}
          onClick={() => onChange(0)}
        >
          0
        </Button>
        <Button
          size="small"
          type={isMax ? 'primary' : 'default'}
          onClick={() => onChange(DATAHUB_LINK_MAX)}
        >
          MAX
        </Button>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            ...(isCustom
              ? {
                backgroundColor: token.colorPrimaryBg,
                boxShadow: `inset 0 0 0 1px ${token.colorPrimary}`,
              }
              : undefined),
          }}
        >
          <InputNumber
            size="small"
            variant={isCustom ? 'borderless' : 'outlined'}
            value={isCustom ? value : null}
            min={1}
            max={DATAHUB_LINK_MAX - 1}
            controls={false}
            onChange={(v) => {
              if (v != null) onChange(v)
            }}
            onFocus={() => {
              if (!isCustom) onChange(1)
            }}
            style={{
              width: '100%',
              ...(isCustom
                ? {
                  color: token.colorPrimary,
                }
                : undefined),
            }}
          />
        </div>
      </Space.Compact>
    </div>
  )
}
